import moment from 'moment-timezone';
/* eslint-disable import/prefer-default-export */
export const calculateGranularity = (startTime, endTime) => {
  const timeDifference = moment(endTime).diff(startTime, 'm');

  let granularity = 'm';
  if (timeDifference < 5) {
    granularity = 'ms';
  } else if (timeDifference < 30) {
    granularity = 's';
  }

  return granularity;
};
